import React from "react";
import Link from "next/link";
import { renderWithBrackets } from "../../lib/renderWithBrackets";

interface SimpleCTAProps {
	title: string;
	ctaText: string;
	ctaLink: string;
	bracketedText?: string; // Text portion to wrap with brackets
	bracketAnimateColors?: boolean; // Whether brackets should animate colors
	bracketColor?: string; // Color for the brackets (defaults to "blue")
}

const SimpleCTA = ({
	title,
	ctaText,
	ctaLink,
	bracketedText,
	bracketAnimateColors = false,
	bracketColor = "blue",
}: SimpleCTAProps) => {
	const renderTitleWithBrackets = () => {
		return renderWithBrackets({
			text: title,
			bracketedText,
			bracketAnimateColors,
			bracketColor,
			fontSize: {
				min: "28px",
				preferred: "2.81vw",
				max: "36px",
			},
			lineHeightMultiplier: 1.25, // leading-tight
		});
	};

	return (
		<div className="space-y-8 px-2 xl:px-0 py-[clamp(40px,6.25vw,80px)] max-w-6xl mx-auto">
			<div className="relative inline-block">
				<p className="text-[clamp(28px,2.81vw,36px)] font-bold leading-tight">
					{renderTitleWithBrackets()}
				</p>
			</div>

			<Link href={ctaLink}>
				<a className="bg-blue text-white font-display py-4 px-12 rounded-md hover:bg-blue/80 transition-colors shadow-lg text-lg inline-flex items-center">
					{ctaText}
				</a>
			</Link>
		</div>
	);
};

export default SimpleCTA;
